import PropTypes from 'prop-types'
import React, {Component} from 'react'
import {Button, Container, Icon, Menu, Segment, Sidebar} from "semantic-ui-react";
import HomepageHeading from "../HomepageHeading";
import {Translate} from "react-localize-redux";
import LanguageDropdown from "../../localisation/LanguageDropdown";

class MobileMenu extends Component {
  state = {};

  handlePusherClick = () => {
    const { sidebarOpened } = this.state;

    if (sidebarOpened) this.setState({ sidebarOpened: false })
  };

  handleToggle = () => this.setState({ sidebarOpened: !this.state.sidebarOpened });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Sidebar.Pushable>
        <Sidebar as={Menu} animation='uncover' inverted vertical visible={sidebarOpened}>
          <Menu.Item as='a' active>
            <Translate id="home"/>
          </Menu.Item>
          <Menu.Item as='a'>Coming soon</Menu.Item>
        </Sidebar>

        <Sidebar.Pusher
          dimmed={sidebarOpened}
          onClick={this.handlePusherClick}
          style={{ minHeight: '100vh' }}
        >
          <Segment
            inverted
            textAlign='center'
            style={{minHeight: '-webkit-fill-available', padding: '1em 0em'}}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size='large'>
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name='sidebar' />
                </Menu.Item>
                <Menu.Item position='right'>
                  <LanguageDropdown/>
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile={true} />
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    )
  }
}

MobileMenu.propTypes = {
  children: PropTypes.node,
};

export default MobileMenu



// WEBPACK FOOTER //
// ./src/components/mobile/MobileMenu.js